import { FC, InputHTMLAttributes } from 'react'

import componentColorVariants from 'src/components/ui/variants/componentColorVariants'
import { cn } from 'src/lib/cn'
import ComponentColor from 'src/types/ItemColor'

interface FlatInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  placeholder?: string
  componentColor?: ComponentColor
  error?: boolean
}

const FlatInput: FC<FlatInputProps> = ({
  className,
  placeholder,
  autoFocus,
  componentColor = ComponentColor.blue,
  error,
  ...othersProps
}) => {
  return (
    <input
      className={cn(
        'text-navy my-1 h-8 w-full rounded-sm border border-gray-200 px-[6.4px] py-0 text-left text-xs font-medium transition-all duration-75 ease-in-out focus:ring-1',
        componentColorVariants({
          ring: componentColor,
        }),
        error && 'ring-cinnabar ring-1',
        className,
      )}
      placeholder={placeholder}
      onKeyPress={e => {
        if (e.key === 'Enter') e.preventDefault()
      }}
      autoFocus={autoFocus}
      data-testid="flat-input"
      data-error={error}
      {...othersProps}
    />
  )
}

export default FlatInput
